export const MAX_SIZE = 10000001;
